import { render, staticRenderFns } from "./engagement-report.vue?vue&type=template&id=bc48923e&scoped=true"
import script from "./engagement-report.vue?vue&type=script&lang=ts"
export * from "./engagement-report.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc48923e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc48923e')) {
      api.createRecord('bc48923e', component.options)
    } else {
      api.reload('bc48923e', component.options)
    }
    module.hot.accept("./engagement-report.vue?vue&type=template&id=bc48923e&scoped=true", function () {
      api.rerender('bc48923e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/engagement-report/engagement-report.vue"
export default component.exports